module.exports = __webpack_public_path__ + "static/media/blog-vector2.e9cd0fa0.svg";